import React from "react";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-primary-dark/5 to-primary/10 text-center overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5 bg-gradient-to-br from-gray-900/10 to-transparent"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto animate-fade-in">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/10 rounded-full mb-6">
              <span className="w-2 h-2 bg-accent rounded-full animate-pulse"></span>
              <span className="text-accent font-semibold text-sm uppercase tracking-widest">About Darim NGO</span>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-gray-800 mb-6 font-heading leading-tight">
              Empowering <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent">Communities</span> Across Uttarakhand
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Since 1997, we've been dedicated to creating sustainable change through
              integrated development programs across all districts of Uttarakhand.
            </p>
            <div className="mt-8 flex justify-center gap-4">
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <span className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center text-primary font-bold">25+</span>
                <span>Years of Service</span>
              </div>
              <div className="w-px h-6 bg-gray-300"></div>
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <span className="w-8 h-8 bg-accent/10 rounded-full flex items-center justify-center text-accent font-bold">13</span>
                <span>Districts Covered</span>
              </div>
              <div className="w-px h-6 bg-gray-300"></div>
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <span className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center text-primary font-bold">50K+</span>
                <span>Lives Impacted</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About the Organisation */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6 font-heading text-center">About the Organisation</h2>
            <div className="w-24 h-1.5 bg-gradient-to-r from-primary to-primary-light mx-auto mb-12 rounded-full"></div>
            
            <div className="text-gray-700 leading-relaxed space-y-6 text-lg">
              <p>
                Founded in the year 1997, the DAREM has been focusing on rural development and upliftment of drudgery of rural women, schedule caste, and Schedule Tribe at remote regions of Uttarakhand. The focus areas have mainly been finding avenues and creating opportunities for employment, market connectivity, rural entrepreneurship, raising nutritional standards, education and social legal awareness amongst the people of the area.
              </p>
              <p>
                DAREM has collaborated with multiple national and international organisations, including UNESCO, Ministry of Science and Technology, CAPART amongst others. The organisation has received technical guidance and assistance from reputed national and international organisations from time to time.
              </p>
            </div>
          </div>
        </div>
      </section>

    {/* Mission, Vision, Values */}
<section className="py-20 relative bg-gradient-to-b from-gray-50 to-white">
  <div className="container mx-auto px-4">
    <div className="text-center mb-16">
      <span className="inline-block text-accent font-semibold text-sm uppercase tracking-widest mb-4">
        About DAREM
      </span>
      <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 font-heading">
        What Drives Our Organisation
      </h2>
      <div className="w-24 h-1 bg-gradient-to-r from-primary to-accent mx-auto rounded-full mb-12"></div>
      <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12">
        Founded in 1997, DAREM has been dedicated to rural development and uplifting 
        marginalized communities, with a special focus on rural women, Scheduled Castes, 
        and Scheduled Tribes in remote regions of Uttarakhand.
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      
      {/* Mission Card */}
      <div className="group bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-3 border border-gray-100 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
        <div className="relative z-10">
          <h3 className="text-2xl font-bold text-gray-800 mb-4 font-heading">Our Mission</h3>
          <p className="text-gray-600 leading-relaxed">
            To empower rural communities by creating sustainable opportunities for 
            employment, entrepreneurship, market connectivity, education, nutritional 
            improvement, and social–legal awareness—ultimately reducing the daily 
            drudgery of rural women, Scheduled Caste, and Scheduled Tribe populations.
          </p>
          <div className="mt-6 pt-4 border-t border-gray-100">
            <Link 
              to="/programs"
              className="inline-flex items-center text-primary font-medium hover:text-primary-dark transition-colors"
            >
              Explore Our Programs <span className="ml-2">→</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Vision Card */}
      <div className="group bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-3 border border-gray-100 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-accent/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
        <div className="relative z-10">
          <h3 className="text-2xl font-bold text-gray-800 mb-4 font-heading">Our Vision</h3>
          <p className="text-gray-600 leading-relaxed">
            To build self-reliant, empowered, and aware rural communities where every 
            individual—especially women and marginalized groups—has access to livelihood 
            opportunities, education, dignified living, and a path to economic independence.
          </p>
          <div className="mt-6 pt-4 border-t border-gray-100"></div>
        </div>
      </div>

      {/* Values Card */}
      <div className="group bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-3 border border-gray-100 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-accent/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
        <div className="relative z-10">
          <h3 className="text-2xl font-bold text-gray-800 mb-4 font-heading">Our Values</h3>
          <div className="space-y-3">
            {[
              { icon: '🤝', value: 'Inclusivity', desc: 'We work prioritizing marginalized groups, ensuring equal opportunities for all.' },
              { icon: '🌿', value: 'Sustainability', desc: 'We promote long-term, eco-friendly, and community-led development.' },
              { icon: '📚', value: 'Awareness', desc: 'We spread social, legal, and educational awareness to empower decision-making.' },
              { icon: '💼', value: 'Livelihood Focus', desc: 'We create employment pathways and support rural entrepreneurs.' },
              { icon: '🌍', value: 'Collaboration', desc: 'We partner with national and international organisations like UNESCO and MST for better impact.' },
            ].map((item, index) => (
              <div key={index} className="flex items-start gap-3">
                <span className="text-lg mt-0.5">{item.icon}</span>
                <div>
                  <p className="font-medium text-gray-800">{item.value}</p>
                  <p className="text-sm text-gray-500">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  </div>
</section>


      {/* Working Area */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <span className="inline-block text-accent font-semibold text-sm uppercase tracking-widest mb-4">
              Our Reach
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6 font-heading">
              Working Area
            </h2>
          </div>

          <div className="overflow-x-auto bg-white rounded-xl shadow-lg border border-gray-100">
            <table className="w-full text-left border-collapse min-w-[800px]">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="p-5 border-b border-primary-light font-bold whitespace-nowrap text-sm uppercase tracking-wider">
                    S. No.
                  </th>
                  <th className="p-5 border-b border-primary-light font-bold whitespace-nowrap text-sm uppercase tracking-wider">
                    State
                  </th>
                  <th className="p-5 border-b border-primary-light font-bold whitespace-nowrap text-sm uppercase tracking-wider">
                    District
                  </th>
                  <th className="p-5 border-b border-primary-light font-bold text-sm uppercase tracking-wider w-1/3">
                    Primary Sectors
                  </th>
                  <th className="p-5 border-b border-primary-light font-bold text-sm uppercase tracking-wider w-1/3">
                    Secondary Sectors
                  </th>
                </tr>
              </thead>
              <tbody className="text-gray-700">
                <tr className="hover:bg-gray-50 transition-colors">
                  <td className="p-5 border-b border-gray-100 align-top font-medium">
                    1
                  </td>
                  <td className="p-5 border-b border-gray-100 align-top font-bold text-primary">
                    Uttarakhand
                  </td>
                  <td className="p-5 border-b border-gray-100 align-top font-bold">
                    ALL
                  </td>
                  <td className="p-5 border-b border-gray-100 align-top leading-relaxed">
                    Agriculture, Animal Husbandry, Dairying & Fisheries, Civic
                    Issues, Dalit Upliftment, Drinking Water
                  </td>
                  <td className="p-5 border-b border-gray-100 align-top leading-relaxed">
                    Education & Literacy, Food Processing, Labour & Employment,
                    Micro Small & Medium Enterprises, Science & Technology,
                    Vocational Training, Water Resources
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Organization Info */}
    <section className="py-16 bg-white">
  <div className="container mx-auto px-4">
    <div className="max-w-4xl mx-auto">

      {/* Header */}
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 font-heading">
          DARIM – Organization Details
        </h2>
        <p className="text-gray-500 mt-2">
          Gramin Krishi Vikas Avam Paryavaran Sambhardan Sanstha
        </p>
        <div className="w-16 h-1 bg-primary mx-auto mt-4 rounded-full"></div>
      </div>

      {/* Card */}
      <div className="bg-gray-50 rounded-xl p-8 border border-gray-200">

        {/* Info Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          
          {/* Left Column */}
          <div className="space-y-6">
            <div>
              <p className="text-sm text-gray-500">Official Name</p>
              <p className="font-medium text-gray-800">
                DARIM – Gramin Krishi Vikas Avam Paryavaran Sambhardan Sanstha
              </p>
            </div>

            <div>
              <p className="text-sm text-gray-500">Founded</p>
              <p className="font-medium text-gray-800">1997</p>
            </div>

            <div>
              <p className="text-sm text-gray-500">Headquarters</p>
              <p className="font-medium text-gray-800">Tehri Garhwal, Uttarakhand</p>
            </div>

            <div>
              <p className="text-sm text-gray-500">Industry</p>
              <p className="font-medium text-gray-800">Non-Profit Organization</p>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-6">
            <div>
              <p className="text-sm text-gray-500">Website</p>
              <a
                href="https://darimindia.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-primary hover:underline"
              >
                https://darimindia.org/
              </a>
            </div>

            <div>
              <p className="text-sm text-gray-500">Phone</p>
              <a
                href="tel:+918979151025"
                className="font-medium text-gray-800 hover:text-primary"
              >
                +91 8979151025
              </a>
            </div>

            <div>
              <p className="text-sm text-gray-500">Team Size</p>
              <p className="font-medium text-gray-800">2–10 Employees</p>
            </div>

            <div>
              <p className="text-sm text-gray-500">Associated Members</p>
              <p className="font-medium text-gray-800">14 Members</p>
            </div>
          </div>
        </div>

        {/* Mission */}
        <div className="mt-10 pt-6 border-t border-gray-300">
          <h3 className="text-lg font-semibold text-gray-800 mb-2">Our Mission</h3>
          <p className="text-gray-600 leading-relaxed">
            DARIM is a non-profit organization dedicated to sustainable rural 
            development. We work to empower rural women, Scheduled Caste and 
            Scheduled Tribe communities by improving livelihood opportunities, 
            providing market linkage support, and enhancing social, legal, and 
            educational awareness.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>


      {/* Our Story */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="order-2 lg:order-1">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/10 rounded-full mb-6">
                <span className="w-2 h-2 bg-accent rounded-full animate-pulse"></span>
                <span className="text-accent font-semibold text-sm uppercase tracking-widest">Our Journey</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 font-heading">DARIM's Evolution & Impact</h2>
              <div className="space-y-8">
                <div className="group relative pl-8">
                  <div className="absolute left-0 top-2 w-4 h-4 bg-primary rounded-full"></div>
                  <div className="absolute left-2 top-6 w-0.5 h-full bg-primary/20"></div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">1997 - Humble Beginnings</h3>
                  <p className="text-gray-600 leading-relaxed text-lg">
                    Founded in 1997, DAREM (Gramin Krishi Vikas Avam Paryavaran Sambhardan Sanstha) 
                    began with a vision to transform rural communities in Uttarakhand. Our initial 
                    focus was on addressing the challenges faced by women, scheduled castes, and 
                    scheduled tribes in remote regions of the state.
                  </p>
                </div>
                <div className="group relative pl-8">
                  <div className="absolute left-0 top-2 w-4 h-4 bg-accent rounded-full"></div>
                  <div className="absolute left-2 top-6 w-0.5 h-full bg-accent/20"></div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">Expanding Our Reach</h3>
                  <p className="text-gray-600 leading-relaxed text-lg">
                    Over the years, we've expanded our initiatives across all 13 districts of 
                    Uttarakhand. Our work has evolved to include comprehensive programs in 
                    employment generation, market connectivity, rural entrepreneurship, 
                    nutritional security, education, and social-legal awareness.
                  </p>
                </div>
                <div className="group relative pl-8">
                  <div className="absolute left-0 top-2 w-4 h-4 bg-primary rounded-full"></div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">Strategic Partnerships</h3>
                  <p className="text-gray-600 leading-relaxed text-lg">
                    Our growth has been supported by collaborations with esteemed organizations 
                    including UNESCO, the Ministry of Science and Technology, and CAPART. These 
                    partnerships have provided valuable technical guidance and resources, enabling 
                    us to scale our impact and implement innovative solutions for rural development.
                  </p>
                </div>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-accent/20 rounded-3xl transform rotate-3"></div>
                <div className="relative bg-gradient-to-br from-primary to-accent rounded-3xl p-12 text-center min-h-[450px] flex flex-col items-center justify-center text-white shadow-2xl transform hover:-translate-y-2 transition-transform duration-500">
                  <div className="w-24 h-24 bg-white/20 rounded-full flex items-center justify-center mb-8 backdrop-blur-sm">
                    <span className="text-6xl animate-pulse">🌱</span>
                  </div>
                  <p className="text-2xl font-bold mb-4">Our Core Focus Areas</p>
                  <div className="space-y-4 mb-8">
                    <p className="flex items-center gap-2">
                      <span className="w-2 h-2 bg-white rounded-full"></span>
                      Rural Development
                    </p>
                    <p className="flex items-center gap-2">
                      <span className="w-2 h-2 bg-white rounded-full"></span>
                      Women's Empowerment
                    </p>
                    <p className="flex items-center gap-2">
                      <span className="w-2 h-2 bg-white rounded-full"></span>
                      Sustainable Livelihoods
                    </p>
                  </div>
                  <div className="mt-auto w-full">
                    <div className="h-1 bg-white/20 rounded-full mb-4">
                      <div className="h-full bg-white w-3/4 rounded-full"></div>
                    </div>
                    <p className="text-sm text-white/80">Transforming communities since 1997</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Apeato Connection */}
      <section className="py-20 bg-gray-50 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-100/50 to-transparent"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-16">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/10 rounded-full mb-6">
                <span className="w-2 h-2 bg-accent rounded-full animate-pulse"></span>
                <span className="text-accent font-semibold text-sm uppercase tracking-widest">A Social Enterprise by DARIM</span>
              </div>
              <div className="flex justify-center mb-8">
                <img 
                  src="https://res.cloudinary.com/djwtbym2y/image/upload/v1763643861/colored-logo_kndmll.png" 
                  alt="Apeato by Bugyal Foods" 
                  className="h-24 w-auto object-contain"
                  loading="lazy"
                />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6 font-heading">Our Vision for Apeato</h2>
              <div className="w-24 h-1 bg-gradient-to-r from-accent to-primary mx-auto rounded-full mb-8"></div>
              <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
                A pioneering social enterprise that bridges the gap between business and social impact, creating sustainable change in Uttarakhand's communities.
              </p>
            </div>
            
            <div className="bg-white rounded-3xl shadow-2xl p-12 border border-gray-100">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12">
                <div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-6 font-heading">Empowering Through Enterprise</h3>
                  <p className="text-gray-600 leading-relaxed text-lg mb-8">
                    Apeato represents our commitment to sustainable development through innovative business solutions. Every product sold creates a ripple effect of positive change, supporting our community programs and creating opportunities for rural artisans and farmers across Uttarakhand.
                  </p>
                  <div className="space-y-4">
                    <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl">
                      <div className="w-12 h-12 bg-green-100 rounded-xl flex-shrink-0 flex items-center justify-center text-green-600 text-xl">
                        🌱
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-800">Sustainable Impact</h4>
                        <p className="text-gray-600 text-sm">100% of profits directly fund our community development initiatives</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl">
                      <div className="w-12 h-12 bg-blue-100 rounded-xl flex-shrink-0 flex items-center justify-center text-blue-600 text-xl">
                        🤝
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-800">Community First</h4>
                        <p className="text-gray-600 text-sm">Supporting local artisans and farmers with fair trade practices</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-xl">
                      <div className="w-12 h-12 bg-purple-100 rounded-xl flex-shrink-0 flex items-center justify-center text-purple-600 text-xl">
                        ♻️
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-800">Eco-Friendly</h4>
                        <p className="text-gray-600 text-sm">Committed to sustainable and environmentally responsible production</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-accent/20 to-primary/20 rounded-3xl transform -rotate-3"></div>
                  <div className="relative bg-white rounded-3xl p-8 text-center shadow-2xl border border-gray-100">
                    <div className="mb-8">
                      <img 
                        src="https://res.cloudinary.com/djwtbym2y/image/upload/v1763643861/colored-logo_kndmll.png" 
                        alt="Apeato by Bugyal Foods" 
                        className="h-40 mx-auto object-contain"
                        loading="lazy"
                      />
                    </div>
                    <p className="text-lg text-gray-600 mb-6">A Social Enterprise by Bugyal Foods</p>
                    <p className="text-gray-700 mb-8">Transforming communities through sustainable business</p>
                    <a 
                      href="https://apeato.com" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-block w-full py-3 px-6 bg-gradient-to-r from-primary to-accent text-white rounded-full font-medium hover:opacity-90 transition-opacity"
                    >
                      Visit Apeato
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 py-10 border-y-2 border-gray-200">
                <div className="text-center group">
                  <div className="w-20 h-20 bg-gradient-to-br from-primary to-primary-light rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <span className="text-2xl font-bold text-white">100%</span>
                  </div>
                  <p className="text-lg font-bold text-gray-800 mb-1">Profits to NGO</p>
                  <p className="text-sm text-gray-600">Every contribution matters</p>
                </div>
                <div className="text-center group">
                  <div className="w-20 h-20 bg-gradient-to-br from-accent to-accent-light rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <span className="text-2xl font-bold text-white">1997</span>
                  </div>
                  <p className="text-lg font-bold text-gray-800 mb-1">Year Established</p>
                  <p className="text-sm text-gray-600">Decades of experience</p>
                </div>
                <div className="text-center group">
                  <div className="w-20 h-20 bg-gradient-to-br from-gray-700 to-gray-900 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <span className="text-2xl font-bold text-white">∞</span>
                  </div>
                  <p className="text-lg font-bold text-gray-800 mb-1">Sustainable Impact</p>
                  <p className="text-sm text-gray-600">Creating lasting change</p>
                </div>
              </div>
              
              <div className="text-center mt-12">
                <a
                  href="https://apeato.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-gradient-to-r from-primary to-accent text-white rounded-full text-lg font-bold shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                >
                  <span>Explore Apeato</span>
                  <span className="text-xl">→</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="relative py-24 bg-gradient-to-br from-primary to-accent text-white text-center overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-float"></div>
          <div className="absolute bottom-10 right-10 w-24 h-24 bg-white/5 rounded-full animate-float-reverse"></div>
          <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-white/5 rounded-full animate-pulse"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 rounded-full mb-8 backdrop-blur-sm">
              <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
              <span className="text-white font-semibold text-sm uppercase tracking-widest">Join Our Mission</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 font-heading">Together We Can Create <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-white/80">Lasting Change</span></h2>
            <p className="text-xl text-white/90 mb-12 leading-relaxed max-w-2xl mx-auto">
              Whether through donations, volunteering, or partnerships, your support
              helps us create lasting change in communities across Uttarakhand.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 max-w-3xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="text-3xl mb-3">💝</div>
                <h4 className="font-bold text-lg mb-2">Donate</h4>
                <p className="text-white/80 text-sm">Support our programs financially</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="text-3xl mb-3">🤝</div>
                <h4 className="font-bold text-lg mb-2">Volunteer</h4>
                <p className="text-white/80 text-sm">Give your time and skills</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="text-3xl mb-3">🤝</div>
                <h4 className="font-bold text-lg mb-2">Partner</h4>
                <p className="text-white/80 text-sm">Collaborate with us</p>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row justify-center gap-6">
              <Link
                to="/donate"
                className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white text-primary rounded-full text-lg font-bold shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300"
              >
                <span>Support Our Work</span>
                <span className="text-xl">❤️</span>
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-8 py-4 bg-transparent border-2 border-white text-white rounded-full text-lg font-bold hover:bg-white hover:text-primary transition-all duration-300"
              >
                <span>Get in Touch</span>
                <span className="text-xl">→</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
